import { Badge } from "@/components/ui/badge";

import { signalTypeLabel } from "./signals";

/** Badge for a signal type id; `title` carries the detail when there is one. */
export function SignalBadge({
  typeId,
  title,
}: {
  typeId: string;
  title?: string;
}) {
  return (
    <Badge variant="destructive" title={title}>
      {signalTypeLabel(typeId)}
    </Badge>
  );
}

/** One badge per live signal type, for list rows and cards. */
export function SignalBadges({ types }: { types?: string[] | null }) {
  if (!types?.length) return null;
  return (
    <>
      {types.map((type) => (
        <span key={type} className="ml-2 align-middle">
          <SignalBadge typeId={type} />
        </span>
      ))}
    </>
  );
}
